import { apiFetch } from "./client";

export type NotificationKind =
  | "ORDER_STATUS_CHANGED"
  | "CONTRACT_SENT"
  | "CONTRACT_SIGNED"
  | "CONTRACT_EXPIRY_WARNING"
  | "INVITATION_ACCEPTED"
  | "GENERIC";

export type NotificationView = {
  id: string;
  kind: NotificationKind;
  titleKey: string;
  bodyKey: string | null;
  placeholders: Record<string, unknown>;
  data: Record<string, unknown>;
  href: string | null;
  read: boolean;
  readAt: string | null;
  createdAt: string;
};

export const notificationsApi = {
  list: () => apiFetch<NotificationView[]>("/notifications"),
  unreadCount: () => apiFetch<{ count: number }>("/notifications/unread-count"),
  markRead: (id: string) =>
    apiFetch<void>(`/notifications/${id}/read`, { method: "POST" }),
  markAllRead: () =>
    apiFetch<{ updated: number }>("/notifications/read-all", { method: "POST" }),
};
